/**
 * @Author: wangzhuang@baidu.com
 * @Date: 2023-01-10 17:48:54
 * @LastEditors: v_huangyongxing@baidu.com
 * @LastEditTime: 2024-04-26 11:19:55
 * @FilePath: /m-anquan-baidu-com/src/containers/product/index.js
 * @Description: 产品二级页
 */

import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import ProBanner from '../../components/ProBanner';
import ProductTitle from '../../components/ProductTitle';
import NumberAuth from './numberAuth';
import PageTemperature from './page_temperature';
import Compliance from './compliance';
import Vdc from './vdc';
import PageAppSolution from './page_app_solution';
import PageImageRecignition from './page_imagerecognition';
import PageInspection from './page_inspection';
import SecurityPrivacy from './securityPrivacy';
import PageLuBang from './pageLuBang';
import PageUrlSec from './pageUrlSec';
import PageTic from './pageTic';
import PageTextCheck from './pageTextCheck';
import PageBrain from './pageBrain';
import PageCommercialPassword from './pageCommercialPassword';
import PageSecureSmartLock from './pageSecureSmartLock';
import PageLargeModelSecurity from './pageLargeModelSecurity';
import PageIntelligentDataSecurityGateway from './pageIntelligentDataSecurityGateway';

// 特殊的套餐模块 产品中的 pageType = 5006
// import PageScanBlock from './page_scan_block';
import {fetchPagesDataById, fetchServiceIntroduce, fetchProductId} from '../../actions/productAction';
import {fetchUrlUpload} from '../../actions/fileCheckAction';

import './index.less';

let nextMap = {
    '1': '使用服务',
    '2': '购买服务',
    '3': '试用服务',
    '4': '申请服务',
    '0': null,
};

let skillImgData = [
    require('../../asset/svg/jishuzhichi.svg'),
    require('../../asset/svg/qqkefu.svg'),
    require('../../asset/svg/shequluntan.svg'),
    require('../../asset/svg/lianxiyouxiang.svg')
];

class Product extends Component {
    static propTypes = {
        fetchUrlUpload: PropTypes.func,
        fetchPagesDataById: PropTypes.func,
        fetchServiceIntroduce: PropTypes.func,
        fetchProductId: PropTypes.func,
        match: PropTypes.object,
        history: PropTypes.object,
        serviceIntroduce: PropTypes.object,
        navigationList: PropTypes.object,
        pagesDatabyid: PropTypes.object,
        navListIndex: PropTypes.object
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            isLoaded: false,
            vdcType: 'search',
            vdcValue: '',
            vdcPage: false,
            vdcText: '请输入待检测文件对应的md5',
            upIng: false
        };

        this.renderScenes = this.renderScenes.bind(this);
        this.renderContact = this.renderContact.bind(this);
        this.onImageLoad = this.onImageLoad.bind(this);
        this.renderTypicalCase = this.renderTypicalCase.bind(this);
    }

    componentWillMount() {
        if (this.isPC()) {
            const id = this.props.match.params.id;
            location.href = `/product/${id}`;
        }
    }

    componentDidMount() {
        let id = this.props.match.params.id;
        this.props.fetchPagesDataById(id).then(data => {
            if (data.data.is_error === 1) {
                location.href = '/m/';
                return;
            }
            let itemlist = data.data.itemlist;
            if (itemlist && itemlist.pages_common.page_type === '4000' && itemlist.pages_content.service) {
                this.props.fetchServiceIntroduce(itemlist.pages_content.service[0].title);
            }


            if (
                itemlist
                && itemlist.pages_common.navigation_name
                && this.isPageTitle('mesatee', itemlist.pages_common.navigation_name)
            ) {
                setTimeout(() => {
                    this.reportData('mesatee_details');
                }, 500);
            }
        });
        this.props.fetchProductId(id);
    }

    componentWillReceiveProps(nextProps) {
        let id = nextProps.match.params.id;
        let pagesDatabyid = nextProps.pagesDatabyid;
        let pagesCommon = '';

        if (!this.isEmptyobj(pagesDatabyid)) {
            pagesCommon = pagesDatabyid.itemlist.pages_common;
        }

        if (!this.isEmptyobj(pagesCommon) && id !== pagesCommon.alias) {
            this.props.history.push(`/product/${pagesCommon.alias}`);
        }
    }

    onImageLoad(status) {
        this.setState({isLoaded: status});
    }

    renderScenes(pagesContent = {}, pageType) {
        const applyScene = pagesContent.apply_scene || [];
        // 产品模块支持价格套餐
        if ((pageType !== '1000' && pageType !== '5006') || applyScene.length <= 0) {
            return null;
        }

        return (
            <div>
                <div className="product-scenes-title">
                    <ProductTitle title="使用场景" />
                </div>

                {applyScene && applyScene.map(item => (
                    <div key={item.id} className="product-scenes-mod">
                        <div className="scenes">
                            <div className="img">
                                <img src={item.mobile_scene_pic} alt="mobile_scene_pic" />
                            </div>
                            <div className="title">{item.title}</div>
                            <div className="content">
                                {item.content}
                            </div>
                            <div className="logo">
                                {!this.state.isLoaded
                                    && <img
                                        src={require('../../asset/image/product/product_sences_bg.png')}
                                        alt="product_sences_bg" />}
                                <img
                                    onLoad={this.onImageLoad.bind(this, true)}
                                    onError={this.onImageLoad.bind(this, false)}
                                    src={item.mobile_customer_logo_pic}
                                    alt="mobile_customer_logo_pic" />
                            </div>
                        </div>
                    </div>
                ))}
            </div>

        );
    }

    renderContact(pagesCommon = {}) {
        const bizConsult = pagesCommon.biz_consult;

        if (!bizConsult) {
            return null;
        }
        return (
            <div className="contact">
                <div className="bg-image"></div>
                <div className="contact-content">
                    <div className="img-wrapper">
                        <div className="img">
                            <div className="img-bg"></div>
                            <img src={bizConsult.mobile_pic} alt="mobile_pic" />
                        </div>
                        <div className="des">
                            <div>{bizConsult.name}</div>
                            <div>{bizConsult.position}</div>
                        </div>
                    </div>
                    <div className="introduction">
                        <div>{bizConsult.desp}</div>
                        <div
                            onClick={() => location.href = `/m/apply/${pagesCommon.id}`}
                            className="introduction-btn">
                            商务咨询
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderTypicalCase(typicalCase) {
        return (
            typicalCase.length > 0
            && <div>
                <div className={'product-mod'}>
                    <ProductTitle title={'典型案例'} />
                </div>
                <div className={'product-mod example-box'}>
                    {
                        typicalCase.map((item, index) => {
                            return <a
                                className={'mui-flex'}
                                href={`/m/community/${item.id}/1/3`}
                                key={index}>
                                <div style={{width: '4rem'}}>
                                    <img
                                        src={item.logo_pic}
                                        alt={item.title}
                                        width={'100%'}
                                    />
                                </div>
                                <div className={'example-right'}>
                                    <div>{item.note}</div>
                                    <span>查看详情&gt;&gt;</span>
                                </div>
                            </a>;
                        })
                    }
                </div>
            </div>
        );
    }

    renderLearnMore(learnMore, next_index) {
        if (learnMore.length === 1) {
            const item = learnMore[0] || {};
            if (next_index === '0') {
                return (
                    <a href={item.content} target="_blank" className="compliance-btn compliance-btn-border">
                        {item.title}
                    </a>
                );
            } else {
                return (
                    <a
                        href={item.content}
                        target="_blank"
                        className="compliance-btn compliance-btn-border"
                        style={{left: '7rem'}}
                    >
                        {item.title}
                    </a>
                );
            }
        }

        return learnMore.length
            ? <div className={'about-tab'}>
                <div className={'about-slide'}>
                    <ul>
                        {
                            learnMore.map((item, index) => {
                                return <li key={index}>
                                    <a href={item.content} target={'_blank'}>{item.title}</a>
                                </li>;
                            })
                        }
                    </ul>
                </div>
                <div className={'tab-shadow'} />
                <div className={'tab-shadow'} />
            </div>
            : null;
    }

    /**
     * @description 渲染产品页面
     * @param {Object} props - 组件属性对象，包含pagesDatabyid、serviceIntroduce等信息
     * @returns {JSX.Element} 返回JSX元素，展示产品页面的内容
     */
    render() {
        const {pagesDatabyid, serviceIntroduce} = this.props;
        let pagesCommon = '';
        let pagesContent = '';
        let pageType = ''; // 1000=安全产品 2000=安全服务 3000=解决方案 4000=开放服务
        let urlText = '';
        let proinfoBoxTitle = '';
        let proinfoBox = [];
        let profunBoxTitle = '';
        let profunBox = '';
        let techSupport = [];
        let serviceFlow = [];
        let typicalCase = [];
        let learnMore = [];
        let url = '';
        let nextText = '';
        let nextUrl = '';

        if (!this.isEmptyobj(pagesDatabyid)) {
            pagesCommon = pagesDatabyid.itemlist.pages_common;
            pagesContent = pagesDatabyid.itemlist.pages_content;
            typicalCase = pagesCommon.typical_case || [];
            pageType = pagesCommon.page_type;
            learnMore = pagesContent.learnMore || [];
            switch (pageType) {
                case '1000':
                case '5006':
                    proinfoBoxTitle = '产品特色';
                    profunBoxTitle = '产品功能';
                    proinfoBox = pagesContent.prod_feature ? pagesContent.prod_feature : [];
                    profunBox = pagesContent.prod_function ? pagesContent.prod_function : [];
                    break;
                case '2000':
                    proinfoBoxTitle = '服务优势';
                    profunBoxTitle = '服务内容';
                    proinfoBox = pagesContent.service_advantage ? pagesContent.service_advantage : [];
                    profunBox = pagesContent.service_content ? pagesContent.service_content : [];
                    serviceFlow = pagesContent.service_flow ? pagesContent.service_flow : [];
                    break;
                case '3000':
                    proinfoBoxTitle = '适用场景';
                    profunBoxTitle = '方案特点';
                    profunBox = pagesContent.program_features ? pagesContent.program_features : [];
                    break;
                case '4000':
                    proinfoBoxTitle = '应用场景';
                    profunBoxTitle = '能力特点';
                    profunBox = pagesContent.ability_features ? pagesContent.ability_features : [];
                    techSupport = pagesContent.tech_support ? pagesContent.tech_support : [];
                    break;
            }
            urlText = pagesCommon.alias === 'ddos' ? '产品咨询 限时试用' : '商务咨询';
            url = `/m/apply/${pagesCommon.id}`;
            nextUrl = pagesCommon.next_url;
            nextText = nextMap[pagesCommon.next_index];
            // if (pagesCommon.next_index === '2') {
            //     url = pagesCommon.next_url;
            // } else if (pagesCommon.next_index === '4') {
            //     url = '/m/apply-app';
            // } else {
            //     url = `/m/apply/${pagesCommon.id}`;
            // }
        }
        let serviceMeals = [];
        if (!this.isEmptyobj(serviceIntroduce)) {
            serviceMeals = serviceIntroduce.itemlist.service_info.service_meals;
        }
        // 号码认证
        if (pageType === '5001' && !this.isEmptyobj(pagesDatabyid)) {
            return <NumberAuth
                bannerInfo={{
                    title: pagesCommon.navigation_name,
                    bgImg: pagesCommon.mobile_banner_pic
                        ? pagesCommon.mobile_banner_pic : require('../../asset/image/product/number_auth_bg.png'),
                    bannerNote: '百度号码认证提供企业号码认证，企业号码申诉，个人号码申诉和常用号码查询服务',
                    url: url,
                    urlText: urlText,
                    nextUrl: nextUrl,
                    nextText: nextText
                }}
            />;
        }
        // 墨源文件威胁感知系统
        if (pageType === '5002' && !this.isEmptyobj(pagesDatabyid)) {
            return <Vdc
                bannerInfo={{
                    title: pagesCommon.navigation_name,
                    bgImg: pagesCommon.mobile_banner_pic
                        ? pagesCommon.mobile_banner_pic : require('../../asset/image/product/banner.png'),
                    bannerNote: pagesCommon.banner_note,
                    url: url,
                    urlText: urlText,
                    nextUrl: nextUrl,
                    nextText: nextText
                }}
            />;
        }

        if (pageType === '5004' && !this.isEmptyobj(pagesDatabyid)) {
            return <PageTemperature
                bannerInfo={{
                    title: pagesCommon.navigation_name,
                    bgImg: pagesCommon.mobile_banner_pic
                        ? pagesCommon.mobile_banner_pic : require('../../asset/image/page_temperature/banner-wap.png'),
                    bannerNote: pagesCommon.banner_note,
                    url: url,
                    urlText: urlText,
                    nextUrl: nextUrl,
                    nextText: nextText
                }}
            />;
        }

        if (pageType === '5005' && !this.isEmptyobj(pagesDatabyid)) {
            return <Compliance
                bannerInfo={{
                    title: pagesCommon.navigation_name,
                    bgImg: pagesCommon.mobile_banner_pic
                        ? pagesCommon.mobile_banner_pic : require('../../asset/image/compliance/banner.png'),
                    bannerNote: pagesCommon.banner_note,
                    url: url,
                    urlText: urlText,
                    nextUrl: nextUrl,
                    nextText: nextText
                }}
            />;
        }


        if (pageType === '5008' && !this.isEmptyobj(pagesDatabyid)) {
            return <PageAppSolution
                bannerInfo={{
                    title: pagesCommon.navigation_name,
                    bgImg: pagesCommon.mobile_banner_pic
                        ? pagesCommon.mobile_banner_pic : require('../../asset/image/page_app_solution/banner.png'),
                    bannerNote: pagesCommon.banner_note,
                    url: url,
                    urlText: urlText,
                    nextUrl: nextUrl,
                    nextText: nextText
                }}
            />;
        }

        if (pageType === '5007' && !this.isEmptyobj(pagesDatabyid)) {
            return <PageImageRecignition
                bannerInfo={{
                    title: pagesCommon.navigation_name,
                    bgImg: pagesCommon.mobile_banner_pic
                        ? pagesCommon.mobile_banner_pic : require('../../asset/image/page_imagerecognition/banner.png'),
                    bannerNote: pagesCommon.banner_note,
                    url: url,
                    urlText: urlText,
                    nextUrl: nextUrl,
                    nextText: nextText
                }}
            />;
        }

        if (pageType === '5009' && !this.isEmptyobj(pagesDatabyid)) {
            return <SecurityPrivacy
                bannerInfo={{
                    title: pagesCommon.navigation_name,
                    bgImg: pagesCommon.mobile_banner_pic
                        ? pagesCommon.mobile_banner_pic : require('../../asset/image/product/sp_banner.png'),
                    bannerNote: pagesCommon.banner_note,
                    url: url,
                    urlText: urlText,
                    nextUrl: nextUrl,
                    nextText: nextText
                }}
            />;
        }

        if (pageType === '5010' && !this.isEmptyobj(pagesDatabyid)) {
            return <PageLuBang
                bannerInfo={{
                    title: pagesCommon.navigation_name,
                    bgImg: pagesCommon.mobile_banner_pic
                        ? pagesCommon.mobile_banner_pic : require('../../asset/image/product/lb-banner.png'),
                    bannerNote: pagesCommon.banner_note,
                    url: url,
                    urlText: urlText,
                    nextUrl: nextUrl,
                    nextText: nextText
                }}
            />;
        }

        if (pageType === '5011' && !this.isEmptyobj(pagesDatabyid)) {
            return <PageInspection
                bannerInfo={{
                    title: pagesCommon.navigation_name,
                    bgImg: pagesCommon.mobile_banner_pic
                        ? pagesCommon.mobile_banner_pic : require('../../asset/image/page_inspection/banner.png'),
                    bannerNote: pagesCommon.banner_note,
                    url: url,
                    urlText: urlText,
                    nextUrl: nextUrl,
                    nextText: nextText
                }}
            />;
        }

        if (pageType === '5012' && !this.isEmptyobj(pagesDatabyid)) {
            return <PageUrlSec
                bannerInfo={{
                    title: pagesCommon.navigation_name,
                    bgImg: pagesCommon.mobile_banner_pic,
                    bannerNote: pagesCommon.banner_note,
                    url: url,
                    urlText: urlText,
                    nextUrl: nextUrl,
                    nextText: nextText
                }}
            />;
        }

        if (pageType === '5013' && !this.isEmptyobj(pagesDatabyid)) {
            return <PageTic
                bannerInfo={{
                    title: pagesCommon.navigation_name,
                    bgImg: pagesCommon.mobile_banner_pic,
                    bannerNote: pagesCommon.banner_note,
                    url: url,
                    urlText: urlText,
                    nextUrl: nextUrl,
                    nextText: nextText
                }}
            />;
        }

        if (pageType === '5014' && !this.isEmptyobj(pagesDatabyid)) {
            return <PageTextCheck
                bannerInfo={{
                    title: pagesCommon.navigation_name,
                    bgImg: pagesCommon.mobile_banner_pic
                        ? pagesCommon.mobile_banner_pic : require('../../asset/image/pageTextCheck/banner.png'),
                    bannerNote: pagesCommon.banner_note,
                    url: url,
                    urlText: urlText,
                    nextUrl: nextUrl,
                    nextText: nextText
                }}
            />;
        }

        if (pageType === '5015' && !this.isEmptyobj(pagesDatabyid)) {
            return <PageBrain
                bannerInfo={{
                    title: pagesCommon.navigation_name,
                    bgImg: pagesCommon.mobile_banner_pic
                        ? pagesCommon.mobile_banner_pic : require('../../asset/image/pageBrain/banner.png'),
                    bannerNote: pagesCommon.banner_note,
                    url: url,
                    urlText: urlText,
                    nextUrl: nextUrl,
                    nextText: nextText
                }}
            />;
        }

        if (pageType === '5016' && !this.isEmptyobj(pagesDatabyid)) {
            return <PageCommercialPassword
                bannerInfo={{
                    title: pagesCommon.navigation_name,
                    bgImg: pagesCommon.mobile_banner_pic
                        ? pagesCommon.mobile_banner_pic
                        : require('../../asset/image/pageCommercialPassword/banner.png'),
                    bannerNote: pagesCommon.banner_note,
                    url: url,
                    urlText: urlText,
                    nextUrl: nextUrl,
                    nextText: nextText
                }}
            />;
        }

        if (pageType === '5017' && !this.isEmptyobj(pagesDatabyid)) {
            return <PageSecureSmartLock
                bannerInfo={{
                    title: pagesCommon.navigation_name,
                    bgImg: pagesCommon.mobile_banner_pic
                        ? pagesCommon.mobile_banner_pic : require('../../asset/image/pageSecureSmartLock/banner.png'),
                    bannerNote: pagesCommon.banner_note,
                    url: url,
                    urlText: urlText,
                    nextUrl: nextUrl,
                    nextText: nextText
                }}
            />;
        }

        if (pageType === '5018' && !this.isEmptyobj(pagesDatabyid)) {
            return <PageLargeModelSecurity
                bannerInfo={{
                    title: pagesCommon.navigation_name,
                    bgImg: pagesCommon.mobile_banner_pic
                        ? pagesCommon.mobile_banner_pic
                        : require('../../asset/image/pageLargeModelSecurity/banner.png'),
                    bannerNote: pagesCommon.banner_note,
                    url: url,
                    urlText: urlText,
                    nextUrl: nextUrl,
                    nextText: nextText,
                    learnMore: learnMore,
                    nextIndex: pagesCommon.next_index
                }}
            />;
        }

        if (pageType === '5019' && !this.isEmptyobj(pagesDatabyid)) {
            return <PageIntelligentDataSecurityGateway
                bannerInfo={{
                    title: pagesCommon.navigation_name,
                    bgImg: pagesCommon.mobile_banner_pic,
                    bannerNote: pagesCommon.banner_note,
                    proinfoBox: pagesContent.prod_feature ? pagesContent.prod_feature : [],
                    profunBox: pagesContent.prod_function ? pagesContent.prod_function : [],
                    url: url,
                    urlText: urlText,
                    nextUrl: nextUrl,
                    nextText: nextText,
                    learnMore: learnMore,
                    nextIndex: pagesCommon.next_index
                }}
            />;
        }

        return (
            !this.isEmptyobj(pagesDatabyid)
                ? <div className={'product'}>
                    <div className="pro-banner-box bg-new">
                        <ProBanner
                            title={pagesCommon.navigation_name}
                            urlText={urlText}
                            bgImg={pagesCommon.mobile_banner_pic}
                            url={url}
                            nextUrl={nextUrl}
                            nextText={nextText}
                        />
                        {this.renderLearnMore(learnMore, pagesCommon.next_index)}
                    </div>

                    <div className={'product-des'}>
                        {pagesCommon.banner_note}
                    </div>

                    {(pageType === '1000'
                        && pagesContent.prod_struct
                        && pagesContent.prod_struct.length > 0)
                        ? <div>
                            <div className={'product-mod'} style={{marginTop: '1rem'}}>
                                <ProductTitle title="业务结构" />
                            </div>

                            <img
                                src={pagesContent.prod_struct[0] && pagesContent.prod_struct[0].mobile_pic}
                                style={{maxWidth: '10rem', margin: '0 auto 1rem'}}
                            />
                        </div>
                        : null}

                    {proinfoBox.length
                        ? <div className={'product-mod'}>
                            <ProductTitle title={proinfoBoxTitle} />
                        </div>
                        : null
                    }

                    {proinfoBox.length
                        ? <div className={'product-mod'}>
                            {
                                proinfoBox.map((item, index) => {
                                    return <div key={index} className={'proinfo-box mui-flex'}>
                                        <div className={'proinfo-box-icon'}>
                                            <img
                                                src={item.mobile_pic}
                                                width={'100%'}
                                                alt={item.title}
                                            />
                                        </div>
                                        <div className={'cell'}>
                                            <div className={'proinfo-box-title'}>{item.title}</div>
                                            <div className={'proinfo-box-des'}>
                                                {item.content}
                                            </div>
                                        </div>
                                    </div>;
                                })
                            }
                        </div>
                        : ''
                    }

                    {pagesCommon.alias === 'ddos'
                        ? <div>
                            <div className={'product-mod'}>
                                <ProductTitle title={'产品选型'} />
                            </div>
                            <img
                                src={pagesContent.lecto_type[0] && pagesContent.lecto_type[0].mobile_pic}
                                style={{maxWidth: '10rem', margin: '0 auto 1rem'}}
                            />
                            <div className={'product-mod'}>
                                <div className={'profun-box mui-flex'}>
                                    <div className={'profun-box-icon'}>
                                        <div className={'star'}>
                                        </div>
                                    </div>
                                    <div className={'cell'}>
                                        <div className={'profun-box-title'}>DDoS防护服务-高防IP</div>
                                        <div
                                            className={'profun-box-des'}>
                                            {/* {item.content} */}
                                            总计T级的DDoS防护能力，BGP线路，速度更快，延迟更小，线路更稳定，默认1个高防IP。
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={'product-mod'}>
                                <table style={{textAlign: 'center'}}
                                    className={'service-meals'} cellPadding={0} cellSpacing={0}>
                                    <thead>
                                        <tr>
                                            <th style={{width: '16%'}}>保底防护套餐</th>
                                            <th style={{width: '15%'}}>线路</th>
                                            <th style={{width: '15%'}}>端口数</th>
                                            <th style={{width: '18%'}}>防护域名数</th>
                                            <th style={{width: '16%'}}>业务宽带</th>
                                            <th style={{width: '20%'}}>费用</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>10Gb</td>
                                            <td>BGP</td>
                                            <td>50</td>
                                            <td>50</td>
                                            <td>100M</td>
                                            <td style={{color: 'red'}}>5800/月</td>
                                        </tr>
                                        <tr>
                                            <td>30Gb</td>
                                            <td>BGP</td>
                                            <td>50</td>
                                            <td>50</td>
                                            <td>100M</td>
                                            <td style={{color: 'red'}}>15800/月</td>
                                        </tr>
                                        <tr>
                                            <td>100Gb</td>
                                            <td>BGP</td>
                                            <td>50</td>
                                            <td>50</td>
                                            <td>100M</td>
                                            <td style={{color: 'red'}}>278000/年</td>
                                        </tr>
                                        <tr>
                                            <td>300Gb</td>
                                            <td>BGP</td>
                                            <td>50</td>
                                            <td>50</td>
                                            <td>100M</td>
                                            <td style={{color: 'red'}}>448000/年</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div
                                    style={{marginTop: '0.2rem',
                                        fontSize: '.36rem',
                                        lineHeight: '.5rem',
                                        color: '#999'
                                    }}>
                                    <div style={{display: 'flex'}}>
                                        <div>
                                        更多套餐请
                                        </div>
                                        <div
                                            style={{color: 'blue'}}
                                            onClick={() => location.href = `/m/apply/${pagesCommon.id}`}>
                                        “联系我们”
                                        </div>
                                    </div>
                                    <div style={{marginTop: '10px'}}>
                                    留下联系方式，即可给予800~10000代金券用以购买百度云高防套餐。
                                    </div>
                                </div>
                            </div>
                        </div>
                        : ''
                    }

                    {
                        pageType === '4000' && pagesContent.application_scene
                            ? <div>
                                <div className={'product-mod'}>
                                    <ProductTitle title={'应用场景'} />
                                </div>
                                <div className={'product-mod'}>
                                    {
                                        pagesContent.application_scene.map((item, index) => {
                                            return <div
                                                className={'pro-application'}
                                                key={index}
                                            >
                                                <div className={'application-title'}>
                                                    {item.title}
                                                </div>
                                                <div className={'application-content'}>
                                                    <img src={item.mobile_pic} alt={item.title} />
                                                </div>
                                            </div>;
                                        })
                                    }
                                </div>
                            </div>
                            : ''
                    }

                    {(pageType !== '1000' && pageType !== '5006' && pagesContent.applicable_scene)

                        ? <div>
                            <div className={'product-mod'}>
                                <ProductTitle title={'适用场景'} />
                            </div>
                            <div className={'product-mod'}>
                                {
                                    pagesContent.applicable_scene.map((item, index) => {
                                        return <div
                                            className={'pro-applicable'}
                                            key={index}
                                            style={{backgroundImage: `url(${item.mobile_pic})`}}
                                        >
                                            <div className={'pro-app-title'}>
                                                {item.title}
                                            </div>
                                            <div className={'pro-app-content'}>
                                                {item.content}
                                            </div>
                                        </div>;
                                    })
                                }
                            </div>
                        </div>
                        : ''
                    }

                    {serviceFlow.length && serviceFlow[0].pic
                        ? <div>
                            <div className={'product-mod'}>
                                <ProductTitle title={'服务流程'} />
                            </div>
                            <div className={'product-mod'}>
                                {
                                    serviceFlow.map((item, index) => {
                                        return <img src={item.mobile_pic} alt="服务流程" width={'100%'} key={index} />;
                                    })
                                }

                            </div>
                        </div>
                        : ''
                    }

                    {profunBox
                        ? <div className={'product-mod'}>
                            <ProductTitle title={profunBoxTitle} />
                        </div>
                        : ''
                    }


                    {profunBox.length
                        ? <div className={'product-mod'}>
                            {
                                profunBox.map((item, index) => {
                                    return <div className={'profun-box mui-flex'} key={index}>
                                        <div className={'profun-box-icon'}>
                                            <div className={'star'}>
                                            </div>
                                        </div>
                                        <div className={'cell'}>
                                            <div className={'profun-box-title'}>{item.title}</div>
                                            <div
                                                className={'profun-box-des'}
                                                dangerouslySetInnerHTML={{__html: item.content}}>
                                                {/* {item.content} */}
                                            </div>
                                        </div>
                                    </div>;
                                })
                            }
                        </div>
                        : ''
                    }

                    {((pageType === '1000' || pageType === '5006') && pagesContent.applicable_scene)

                        ? <div>
                            <div className={'product-mod'}>
                                <ProductTitle title={'适用场景'} />
                            </div>
                            <div className={'product-mod'}>
                                {
                                    pagesContent.applicable_scene.map((item, index) => {
                                        return <div
                                            className={'pro-applicable'}
                                            key={index}
                                            style={{backgroundImage: `url(${item.mobile_pic})`}}
                                        >
                                            <div className={'pro-app-title'}>
                                                {item.title}
                                            </div>
                                            <div className={'pro-app-content'}>
                                                {item.content}
                                            </div>
                                        </div>;
                                    })
                                }
                            </div>
                        </div>
                        : ''
                    }

                    {this.renderScenes(pagesContent, pageType)}

                    {serviceMeals.length
                        ? <div>
                            <div className={'product-mod'}>
                                <ProductTitle title={'产品价格'} />
                            </div>
                            <div className={'product-mod'}>
                                <table className={'service-meals'} cellPadding={0} cellSpacing={0}>
                                    <tr>
                                        <th>套餐名称</th>
                                        <th>查询次数</th>
                                        <th>调用频率</th>
                                        <th>有效时间</th>
                                        <th>价格</th>
                                    </tr>
                                    {
                                        serviceMeals.map((item, index) => {
                                            return <tr key={index}>
                                                <td>{item.name}</td>
                                                <td>{item.capacity}次</td>
                                                <td>{item.second}次/秒</td>
                                                <td>{this.formatTime(item.time)}</td>
                                                <td>{item.price}</td>
                                            </tr>;
                                        })
                                    }
                                </table>
                            </div>
                        </div>
                        : ''
                    }

                    {/* {pageType === '5006' && <PageScanBlock id={this.props.match.params.id}/>} */}

                    {techSupport.length > 0 && <div>
                        <div className={'product-mod'}>
                            <ProductTitle title={'技术支持'} />
                        </div>
                        <div style={{textAlign: 'center'}}>
                            <div className={'product-mod tech-support-box'}>
                                {techSupport.length
                                    ? techSupport.map((item, index) => {
                                        if (item.content && item.content !== ',') {
                                            let pic = '';
                                            let bbscon = item.content.split(',');
                                            let content = '';
                                            switch (item.title) {
                                                case '技术咨询':
                                                    pic = skillImgData[0];
                                                    content = item.content;
                                                    break;
                                                case '客服QQ':
                                                    pic = skillImgData[1];
                                                    content = <a
                                                        href={
                                                            `tencent://message/?uin=435826780&Site=
                                                            ${item.content}&menu=yes`
                                                        }
                                                        className={'tech-support-title'}
                                                    >
                                                        {item.content}
                                                    </a>;
                                                    break;
                                                case '社区论坛':
                                                    pic = skillImgData[2];
                                                    if (bbscon[0]) {
                                                        content = <a
                                                            target="_blank"
                                                            href={`http://${bbscon[1]}`}>
                                                            {bbscon[0]}
                                                        </a>;
                                                    } else {
                                                        content = 'forbid_show';
                                                    }
                                                    break;
                                                case '联系邮箱':
                                                    pic = skillImgData[3];
                                                    content = <a href={`mailto:${item.content}`}>{item.content}</a>;
                                                    break;
                                                default:
                                                    break;
                                            }
                                            return <div className={'tech-support'} key={index}>
                                                <div className={'tech-support-pic'}>
                                                    <img src={pic} alt={item.title} />
                                                </div>
                                                <div className={'tech-support-title'}>
                                                    {item.title}：{content}
                                                </div>
                                            </div>;
                                        }
                                    })
                                    : ''
                                }
                            </div>
                        </div>
                    </div>}

                    {this.renderTypicalCase(typicalCase)}

                    {pagesCommon.mobile_friend
                        ? <div>
                            <div className={'product-mod'}>
                                <ProductTitle title={'合作伙伴'} />
                            </div>
                            <div className={'product-mod'}>
                                <img src={pagesCommon.mobile_friend} alt="合作伙伴" style={{width: '100%'}} />
                            </div>
                        </div>
                        : ''
                    }

                    {pagesCommon && this.renderContact(pagesCommon)}
                </div> : ''
        );
    }
}

function mapStateToProps(state) {
    return {
        pagesDatabyid: state.pagesDatabyid,
        navListIndex: state.navListIndex,
        serviceIntroduce: state.serviceIntroduce
    };
}

function mapDispatchToProps(dispatch) {
    return {
        fetchUrlUpload: (obj, type) => fetchUrlUpload(dispatch, obj, type),
        fetchPagesDataById: id => fetchPagesDataById(dispatch, id),
        fetchServiceIntroduce: itemid => fetchServiceIntroduce(dispatch, itemid),
        fetchProductId: id => fetchProductId(dispatch, id)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Product);



// WEBPACK FOOTER //
// ./src/containers/product/index.js